export function toSampleArrayValue(value: unknown): unknown[] {
  return Array.isArray(value) ? value : [value]
}
